import { List } from "./List";
import { CreateContent } from "./CreateContent";
import { CreatePrompt } from "./CreatePrompt";
import { Detail } from "./Detail";
import { PromptDetail } from "./PromptDetail";

export default {
  List,
  CreateContent,
  CreatePrompt,
  Detail,
  PromptDetail,
};
